module.exports = "/_next/static/images/Frame@2x-122754ac075c2a20514230cee8a026a1.webp";